import React, { useState, useEffect } from "react";
import { API_CONFIG } from "../../../common/constant";
import axios from "axios";
import { getAuthData, getToken } from "../../../common/authService";
import SubscribedPlansCard from "../../../common/component/subscribedPlansCard";
import SubscriptionPaymentCard from "../../home/component/subscriptionPaymentCard";

const SubscribedPlans = ({ homeHandler, handlecenterId }) => {
  const [subscribedPlans, setSubscribedPlans] = useState([]);
  const [purchasePlans, setPurchasePlans] = useState([]);
  const [subscriptionType, setSubscriptionType] = useState("");
  const authData = getAuthData();

  useEffect(() => {
    axios
      .get(`${API_CONFIG.subscribedPlans}`, {
        headers: { accesstoken: getToken() },
      })
      .then((response) => {
        setSubscribedPlans(response.data);
      })
      .catch((error) => console.log(error));
  }, []);

  useEffect(() => {
    if (
      subscriptionType &&
      subscriptionType !== "Free" &&
      subscriptionType !== "Monthly" &&
      subscriptionType !== "Complimentary"
    ) {
      axios
        .get(`${API_CONFIG.purchasePlans}`, {
          headers: { accesstoken: getToken() },
        })
        .then((response) => {
          setPurchasePlans(response.data.products);
        })
        .catch((error) => console.log(error));
    }
  }, [subscriptionType]);

  useEffect(() => {
    if (authData) {
      setSubscriptionType(authData.profile.subscriptionType);
    }
  }, [authData]);

  return (
    <div className="subscribedPlans">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h3>My Subscription</h3>
        <button
          className="subscription-btn"
          onClick={() => {
            homeHandler();
            requestAnimationFrame(() => {
              window.scrollTo({
                top: document.body.scrollHeight,
                behavior: "smooth",
              });
            });
          }}
        >
          Add New Subscription
        </button>
      </div>
      {subscribedPlans?.length ? (
        <>
          <div>
            {(subscriptionType === "Monthly" ||
              subscriptionType === "Free" ||
              subscriptionType === "Complimentary") &&
              subscribedPlans.length > 0 && (
                <div>
                  {subscribedPlans.map((plan) => (
                    <SubscribedPlansCard
                      key={plan._id}
                      plan={plan}
                      homeHandler={homeHandler}
                      handlecenterId={handlecenterId}
                    />
                  ))}
                </div>
              )}
            {(subscriptionType !== "Monthly" ||
              subscriptionType !== "Complimentary") &&
              purchasePlans.length > 0 && (
                <SubscriptionPaymentCard
                  allPlans={purchasePlans}
                  authData={authData}
                />
              )}
          </div>
          <p className="note">Note: Plan is not auto renew</p>
          <button
            onClick={() => {
              homeHandler();
              setTimeout(() => {
                window.scrollTo({
                  top: document.body.scrollHeight,
                  behavior: "smooth",
                });
              }, 100);
            }}
          >
            Add New Subscription
          </button>
        </>
      ) : (
        <div className="loader text-center">
          <svg className="spinner" viewBox="0 0 50 50">
            <circle
              className="path"
              cx="25"
              cy="25"
              r="20"
              fill="none"
              strokeWidth="5"
            ></circle>
          </svg>
        </div>
      )}
    </div>
  );
};

export default SubscribedPlans;
